import axiosInstance from "./AxiosConfig";

class Branches {
  async CreateClient() {}

  async UpdateBranch(id, data) {
    try {
      const response = await axiosInstance.put(`/branch/update/${id}`, data);
      return response.data;
    } catch (error) {
      console.error(error);
      return {
        StatusCode: error?.response?.status,
        error:
          error?.response?.data?.error ||
          error?.response?.data?.message ||
          error?.response?.data?.Message ||
          error?.message ||
          "Request failed",
        Result: error?.response?.data,
      };
    }
  }

  async GetAllClients(pageNo = 1, pageLimit = 100, searchCriteria = "All", searchText = "") {
    try {
      const response = await axiosInstance.get("/branch/get", {
        params: { pageNo, pageLimit, searchCriteria, searchText },
      });
      console.log("Get All response", response);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async DeleteClients(id) {
    try {
      const response = await axiosInstance.delete(`/branch/delete/${id}`);
      console.log("delete response", response);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async BulkUpdateBranches(ids, data) {
    try {
      const response = await axiosInstance.put(`/branch/bulk-update`, {
        ids,
        ...data,
      });
      return response.data;
    } catch (error) {
      console.error(error);
      return {
        StatusCode: error?.response?.status,
        error:
          error?.response?.data?.error ||
          error?.response?.data?.message ||
          error?.response?.data?.Message ||
          error?.message ||
          "Request failed",
        Result: error?.response?.data,
      };
    }
  }
}

export default new Branches();
